// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1RVEH","paramInput":"JobSimulator_paramInput__geVBx","input":"JobSimulator_input__XYvMV"};